import { AbstractQuery } from 'src/models/query';

export class GetAllUnconfirmedAlarmsForUserQuery extends AbstractQuery {
	cacheable = false;
	ignoreCachedResult = true;
	name = 'IFS_Alarm_Query_Queries_GetAllUnconfirmedAlarmsForUserQuery';
	sort = [];
	apiVersion = 2;
}

export class GetAllUnconfirmedBackgroundRefreshAlarmsForUserQuery extends AbstractQuery {
	cacheable = false;
	ignoreCachedResult = true;
	name = 'IFS_Alarm_Query_Queries_GetAllUnconfirmedBackgroundRefreshAlarmsForUserQuery';
	sort = [];
	apiVersion = 2;

	constructor(browser: string, version: string, platform: string) {
		super();

		this.parameters.push({
			browser: browser,
		});

		this.parameters.push({
			version: version,
		});

		this.parameters.push({
			platform: platform,
		});
	}
}
